import styled, { keyframes, css } from 'styled-components';

const spinAnimation = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Svg = styled.svg<{ $spin?: boolean }>`
  ${({ $spin }) => $spin && css`animation: ${spinAnimation} 2.8s linear infinite;`}
`;
